import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "svg-icon svg-icon-xl"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      x: "0",
      y: "0",
      width: "24",
      height: "24"
    }),
    /*#__PURE__*/_createElementVNode("rect", {
      fill: "#000000",
      x: "4",
      y: "4",
      width: "7",
      height: "7",
      rx: "1.5"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M5.5,13 L9.5,13 C10.3284271,13 11,13.6715729 11,14.5 L11,18.5 C11,19.3284271 10.3284271,20 9.5,20 L5.5,20 C4.67157288,20 4,19.3284271 4,18.5 L4,14.5 C4,13.6715729 4.67157288,13 5.5,13 Z M14.5,4 L18.5,4 C19.3284271,4 20,4.67157288 20,5.5 L20,9.5 C20,10.3284271 19.3284271,11 18.5,11 L14.5,11 C13.6715729,11 13,10.3284271 13,9.5 L13,5.5 C13,4.67157288 13.6715729,4 14.5,4 Z M14.5,13 L18.5,13 C19.3284271,13 20,13.6715729 20,14.5 L20,18.5 C20,19.3284271 19.3284271,20 18.5,20 L14.5,20 C13.6715729,20 13,19.3284271 13,18.5 L13,14.5 C13,13.6715729 13.6715729,13 14.5,13 Z",
      fill: "#000000",
      opacity: "0.3"
    })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, " ", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 2,
  class: "menu-bullet"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-alt" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "menu-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    href: "javascript:void(0);",
    class: "menu-link",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickItem && _ctx.clickItem(...args)))
  }, [
    (_ctx.item.type ==='COLLECTION')
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _hoisted_3))
      : (_ctx.item.type === 'FOLDER')
        ? (_openBlock(), _createElementBlock("i", {
            key: 1,
            class: _normalizeClass(["menu-bullet", [_ctx.item.active ? 'fas fa-folder-open' : 'fas fa-folder']])
          }, _hoisted_5, 2))
        : (_openBlock(), _createElementBlock("span", _hoisted_6, _hoisted_8)),
    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.item.name), 1)
  ]))
}